import "./badge.css";
import { Badge, dot } from './badge';
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
export default attachPropertiesToComponent(Badge, {
  dot
});